import { inject, Injectable } from '@angular/core';
import { UserComplete } from './models/account/user-complete.model';
import { Observable } from 'rxjs';
import { ApiWrapperService } from 'ngx-apiwrapper';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
    private readonly _apiWrapper = inject(ApiWrapperService);

    getUserObservable(): Observable<UserComplete> {
        return this._apiWrapper.get<UserComplete>('account');
    }

    getUser(){
        return this._apiWrapper.get<UserComplete>('account');
    }

    updateUser(user:UserComplete){
        var sanitizedUser = user;
        sanitizedUser.eventBookings = [];
        return this._apiWrapper.put<UserComplete>(`account`, sanitizedUser);
    }
}
